module.exports = __webpack_public_path__ + "static/media/imprint-de.4e2c3ae8.md";